export default __webpack_public_path__ + "static/media/single-left-border-both.8a6a57c2.svg";